import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {MainComponent} from './Main/Main.component';
import {PortalHomeComponent} from './Pages/portal-home/portal-home.component';

export const AppRoutes: Routes = [{
  path: '',
  redirectTo: 'home',
  pathMatch: 'full',
},
  {
    path: '',
    component: MainComponent,
    children: [
      {
        path: 'home',
        component: PortalHomeComponent
      }, {
        path: 'contact', loadChildren: () =>
          import('./Pages/contact/contact.module').then(m => m.ContactModule)
      }
      , {
        path: 'glossary', loadChildren: () =>
          import('./Pages/Faq/Faq.module').then(m => m.FaqModule)
      },
      {
        path: 'time-series', loadChildren: () =>
          import('./Pages/time-series/time-series.module').then(m => m.TimeSeriesModule)
      },
      {
        path: 'monitoring', loadChildren: () =>
          import('./Pages/monitoring/monitoring.module').then(m => m.MonitoringModule)
      },
      {
        path: 'info', loadChildren: () =>
          import('./Pages/info/info.module').then(m => m.InfoModule)
      },
      {
        path: 'hydropower', loadChildren: () =>
          import('./Pages/hydropower/hydropower.module').then(m => m.HydropowerModule)
      },
      {
        path: 'sedb', loadChildren: () =>
          import('./Pages/indicator-framework/indicator-framework.module').then(m => m.IndicatorFrameworkModule)
      },
      {
        path: 'pnpca', loadChildren: () =>
          import('./Pages/pnpca/pnpca.module').then(m => m.PnpcaModule)
      },
      {
        path: 'topic', loadChildren: () =>
          import('./Pages/topic/topic.module').then(m => m.TopicModule)
      },
      {
        path: 'map-service', loadChildren: () =>
          import('./Pages/map-service/map-service.module').then(m => m.MapServiceModule)
      },
      {
        path: 'drought', loadChildren: () =>
            import('./Pages/map-service/map-service.module').then(m => m.MapServiceModule)
      },
      {
        path: 'account', loadChildren: () =>
          import('./account/account.module').then(m => m.DataportalcmsAccountModule)
      },
      {
        path: 'data-catalogue', loadChildren: () =>
          import('./Pages/catalogue/catalogue.module').then(m => m.CatalogueModule)
      },
      {
        path: 'cart', loadChildren: () =>
          import('./Pages/datarequest/datarequest.module').then(m => m.DatarequestModule)
      },
      {
        path: 'procedure', loadChildren: () =>
          import('./Pages/cms/cms.module').then(m => m.CmsModule)
      },
      {
        path: 'toolbox', loadChildren: () =>
          import('./Pages/cms/cms.module').then(m => m.CmsModule)
      },
      {
        path: 'about', loadChildren: () =>
          import('./Pages/cms/cms.module').then(m => m.CmsModule)
      },
      {
        path: 'land-cover', loadChildren: () =>
          import('./Pages/cms/cms.module').then(m => m.CmsModule)
      },
      {
        path: 'hydropower', loadChildren: () =>
          import('./Pages/cms/cms.module').then(m => m.CmsModule)
      },
      {
        path: 'dsmp', loadChildren: () =>
          import('./Pages/cms/cms.module').then(m => m.CmsModule)
      },
      {
        path: 'rainfall-monitoring', loadChildren: () =>
          import('./Pages/rainfall-dashboard/rainfall-dashboard.module').then(m => m.RainfallDashboardModule)
      }   ,
      {
        path: 'fishery', loadChildren: () =>
          import('./Pages/fishery/fishery.module').then(m => m.FisheryModule)
      }      ,
      {
        path: 'ehm', loadChildren: () =>
            import('./Pages/ehm/ehm.module').then(m => m.EhmModule)
      }
    ]
  }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(AppRoutes, {})
  ],
  exports: [RouterModule],
  declarations: []
})
export class AppRoutingModule {
}
